import "../item.js";

window.AppointmentBooking ??= {};
window.AppointmentBooking.Wizard ??= {};
window.AppointmentBooking.Wizard.Views ??= {};
window.AppointmentBooking.Wizard.Views.Summary ??= {};

AppointmentBooking.Wizard.Views.Summary.AppointmentSlotItem = class AppointmentSlotItem extends (
  AppointmentBooking.Wizard.Views.Summary.Item
) {
  constructor() {
    super(...arguments);
    this.initialize = this.initialize.bind(this);
  }

  initialize() {
    super.initialize(...arguments);
    return this.listenTo(this.model, "change:appointment_slot change:validated_appointment_slot", this.render);
  }
};
AppointmentBooking.Wizard.Views.Summary.AppointmentSlotItem.prototype.template = "summary/appointment_slot";
AppointmentBooking.Wizard.Views.Summary.AppointmentSlotItem.prototype.className =
  "appointment-booking-wizard-summary-appointment-slot-item";
